import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export type windowBreakpoints = {
  isDesktop?: boolean;
  isMobile?: boolean;
  isTablet?: boolean;
};

export const useDeviceSize = (): windowBreakpoints => {
  const breakpoints = useBreakpoint();

  return {
    isDesktop: breakpoints.lg || breakpoints.xl || breakpoints.xxl,
    isMobile: breakpoints.xs,
    isTablet: (breakpoints.sm || breakpoints.md) && !breakpoints.lg && !breakpoints.xl && !breakpoints.xxl,
  };
};

export default useDeviceSize;
